.border__radius__lg {
  border-radius: var(--border-radius-lg);
}

.mobile-display {
  display: none;
}

.desktop-display {
  display: flex;
}

@media (--reefer-media-tablet-max) {
  .check-icon {
    margin-right: 12px;
  }

  .mobile-display {
    display: flex;
  }

  .desktop-display {
    display: none;
  }
}
